
const SET_SK_INFO = 'set_sk_info'
const SET_SK_CATALOG_INFO = 'set_sk_catalog_info'
const SET_SK_SHOW_FULL = 'set_sk_show_full'

export default {
  state: {
    skInfo: {},
    catalogInfo: {
      info: {},
      resInfo: ''
    },
    full: false,
    interactId: 0
  },
  mutations: {
    [SET_SK_INFO](state, info) {
      state.skInfo = info
    },
    [SET_SK_CATALOG_INFO](state, info) {
      state.catalogInfo = info
    },
    [SET_SK_SHOW_FULL](state, full) {
      state.full = full
    }
  },
  actions: {
    setSkInfo({ commit, state }, { info, cb }) {
      commit(SET_SK_INFO, info)
      cb && cb()
    },
    setSkCatalogInfo({ commit, state }, { info, cb }) {
      commit(SET_SK_CATALOG_INFO, info)
      cb && cb()
    },
    setSkShowFull({ commit, state }, { full, cb }) {
      commit(SET_SK_SHOW_FULL, full)
      cb && cb()
    },
  },
  modules: {
  }
}




// WEBPACK FOOTER //
// ./src/store/giveCourse.js